import React from 'react';

const AWS_CloudFormation = () => {
  return (
    <div>
      <h1>AWS_CloudFormation</h1>
      <p>This is the AWS_CloudFormation component.</p>
    </div>
  );
};

export default AWS_CloudFormation;
